import React from 'react';
import { motion } from 'framer-motion';
import { Battery, Heart, Brain, ArrowRight } from 'lucide-react';

interface RecoveryGuideProps {
  onNext: () => void;
}

export function RecoveryGuide({ onNext }: RecoveryGuideProps) {
  const features = [
    {
      icon: <Heart className="w-6 h-6" />,
      title: 'Heart Rate Variability',
      description: 'Track your nervous system balance'
    },
    {
      icon: <Battery className="w-6 h-6" />,
      title: 'Recovery Score',
      description: 'Daily readiness assessment'
    },
    {
      icon: <Brain className="w-6 h-6" />,
      title: 'Smart Recommendations',
      description: 'AI-powered recovery guidance'
    }
  ];

  return (
    <div className="space-y-8">
      <div className="text-center space-y-4">
        <h3 className="text-2xl font-bold">Recovery Tracking</h3>
        <p className="text-muted-foreground">
          Understand your body's recovery state with advanced metrics and AI analysis
        </p>
      </div>

      <div className="grid gap-6">
        {features.map((feature, index) => (
          <motion.div
            key={feature.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="theme-card p-6 relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
            <div className="relative flex items-center gap-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                {feature.icon}
              </div>
              <div>
                <h4 className="font-semibold">{feature.title}</h4>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <button
        onClick={onNext}
        className="w-full theme-button py-3 rounded-lg flex items-center justify-center gap-2"
      >
        Continue
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}